/** @jsxImportSource @emotion/react */
import { MARPLA_BM_URL } from '@env';
import CoinsIcon from '@marpla/ui/icons/Coins';
import GridIcon from '@marpla/ui/icons/Grid';
import MonitorIcon from '@marpla/ui/icons/Monitor';
import NewsIcon from '@marpla/ui/icons/News';
import UsersIcon from '@marpla/ui/icons/Users';
import WalletIcon from '@marpla/ui/icons/Wallet';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const navLinks = [
  {
    to: '/report/project',
    children: 'SEO',
    icon: GridIcon,
  },
  {
    to: `${MARPLA_BM_URL}/bidder`,
    children: 'Реклама',
    icon: MonitorIcon,
  },
  {
    to: `${MARPLA_BM_URL}/abtest`,
    children: 'A/B тесты',
    icon: ErrorOutlineIcon,
  },
  {
    to: `${import.meta.env.VITE_MARPLA_SALES_URL}`,
    children: 'Продажи',
    icon: CoinsIcon,
  },
  {
    to: '/finance',
    children: 'Тарифы',
    icon: WalletIcon,
  },
  {
    to: '/partner',
    children: 'Партнерка',
    icon: UsersIcon,
  },
  {
    to: 'https://t.me/marpla_ru',
    children: 'Новости',
    icon: NewsIcon,
    blank: true,
  },
];

export default navLinks;
